// Who is calling: the connected wallet, the build and the wallet address
// kind, on every same-origin bridge call, so a server-side rejection line
// (`[social-api]`) can name the wallet without a client line to pair with.

import Wallet from '@/utils/wallet'

const BUILD = /^[0-9a-f]{7,40}$/.test(String(process.env.NEXT_PUBLIC_BUILD_SHA || ''))
	? String(process.env.NEXT_PUBLIC_BUILD_SHA).slice(0, 7)
	: ''

export function owContextHeaders(): Record<string, string> {
	const headers: Record<string, string> = {}
	try {
		const wallet = String(Wallet.type() || '')
		if (/^[a-z0-9_-]{1,32}$/i.test(wallet)) headers['x-ow-wallet'] = wallet.toLowerCase()
	} catch {}
	try {
		const address = String(Wallet.getTaprootAddress() || '')
		if (/^[a-z0-9]{8,90}$/i.test(address)) {
			headers['x-ow-address'] = `${address.slice(0, 5)}..${address.slice(-4)}`
		}
	} catch {}
	if (BUILD) headers['x-ow-build'] = BUILD
	return headers
}
